import React from 'react';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';

import timeclockInstance from '../../config/timeclockInstance';

class RunningTime extends React.Component {
  displayTime = null;

  getTimeByPosition = (position) => {
    return timeclockInstance
      .post('/record-reg/today', {lat: position.lat, lng: position.lng})
      .then((response) => {
        this.displayTime = moment(response.data);
        this.forceUpdate()
      })
  }

  componentDidMount() {
    if (navigator.geolocation) {
      this.geolocation = navigator.geolocation.getCurrentPosition((position) => {
        if (this.willUnmount) return;

        const data = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }
 
        this.getTimeByPosition(data);
      });
    }

    this.interval = setInterval(() => {
      if (this.displayTime) {
        this.displayTime = this.displayTime.clone().add(1 , 'seconds');
        this.forceUpdate();
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.willUnmount = true;
  }

  render() {
    return <Typography color="textSecondary">{this.displayTime ? this.displayTime.format('DD/MM/YYYY[ - ]HH:mm:ss') : ''}</Typography>;
  }
}

export default RunningTime;
